import { usePayloadStore } from '../../stores/payload-store';
import { useJobDataStore } from '../../stores/job-store';

export default async function fetchAdditionalJobData() {
    const payload = usePayloadStore();

    const jobData = useJobDataStore();
    jobData.$patch({
        company: {
            ...jobData.company,
        },
    });

    if (payload.jobId !== 0) {
        /* Asynchronously fetch more data on the job if it hasn't happened already */
        if (!jobData.jobDataFetched) jobData.fetchJobData(payload.jobId);
        if (!jobData.relatedJobsFetched) jobData.fetchRelatedJobs(payload.jobId);
        if (!jobData.recentJobsFetched) jobData.fetchRecentJobs();
    }

    /* Company data is mandatory, wait for this one */
    if (!jobData.companyFetched) {
        await jobData.fetchCompanyData(payload.jobId);
    }
}
